import { ListingSortFieldAndOrder } from "../listing/ListingSortField"
import PriceLevel, { PriceLevelDto } from "./PriceLevel"
import {
    ADD_PRICE_LEVEL,
    SET_INITIAL_VALUES,
    SET_PRICE_LEVELS,
    SORT_PRICE_LEVELS,
    UPDATE_PRICE_LEVELS
} from "./PriceLevelActionType"
import { PriceLevelStateHandler } from "./PriceLevelStateHandler"

export type PriceLevelListingStore = {
    priceLevels: PriceLevelDto[]
}

const defaultState: PriceLevelListingStore = {
    priceLevels: new Array<PriceLevelDto>()
}

type action =
    | { type: SET_INITIAL_VALUES }
    | { type: SET_PRICE_LEVELS; payload: { priceLevels: PriceLevel[] } }
    | { type: ADD_PRICE_LEVEL; payload: { priceLevel: PriceLevel } }
    | { type: UPDATE_PRICE_LEVELS; payload: { priceLevel: PriceLevel } }
    | { type: SORT_PRICE_LEVELS; payload: { sortParams: ListingSortFieldAndOrder } }

function priceLevelListingReducer(state = defaultState, action: action) {
    const handler = PriceLevelStateHandler(state)
    switch (action.type) {
    case SET_INITIAL_VALUES:
        return defaultState
    case SET_PRICE_LEVELS:
        const priceLevels = action.payload.priceLevels.map(p => p.dto)
        return handler.setPriceLevels(priceLevels)
    case ADD_PRICE_LEVEL:
        const priceLevel = action.payload.priceLevel.dto
        return handler.addPriceLevel(priceLevel)
    case UPDATE_PRICE_LEVELS:
        const priceLevelUpdated = action.payload.priceLevel.dto
        return handler.updatePriceLevel(priceLevelUpdated)
    case SORT_PRICE_LEVELS:
        const sortParams = action.payload.sortParams
        return handler.sortPriceLevels(sortParams)
    default:
        return state
    }
}

export default priceLevelListingReducer



// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelListingReducer.ts